import React, { useState } from 'react'
import { Modal, Button, Input, TextArea, Icon } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

export default NiceModal.create(({ orderId, preview }) => {
  const modal = useModal()
  const [subject, setSubject] = useState(preview.subject)
  const [body, setBody] = useState(preview.body)
  const [sending, setSending] = useState(false)

  const onSend = () => {
    if (sending) {
      return
    }

    setSending(true)

    fetch(`/rest/v2/order/${orderId}/trustpilot-invite`, {
      method: 'POST',
      credentials: 'same-origin',
      body: JSON.stringify({ subject, body }),
    })
      .then((response) => response.json())
      .then(({ success, errors }) => {
        setSending(false)

        if (success) {
          toastr.success(`Review invitation queued for ${preview.recipient.name}`)
          modal.resolve()
          modal.remove()
        } else {
          toastr.error((errors || ['Could not queue the review invitation']).join(', '))
        }
      })
      .catch((error) => {
        setSending(false)
        toastr.error(error)
      })
  }

  return (
    <Modal
      show={modal.visible}
      title="Send a Trustpilot review invitation?"
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={onSend}
      dialogPanelClasses="max-w-2xl"
    >
      <div className="space-y-4">
        <div className="text-sm text-gray-600 space-y-1">
          <div>
            <span className="font-medium text-gray-700">To: </span>
            { preview.recipient.name } &lt;{ preview.recipient.email }&gt;
          </div>

          { preview.cc &&
            <div>
              <span className="font-medium text-gray-700">Cc: </span>
              { preview.cc.name } &lt;{ preview.cc.email }&gt;
            </div>
          }

          <div>
            <span className="font-medium text-gray-700">Bcc: </span>
            { preview.bcc } (triggers the Trustpilot invitation)
          </div>
        </div>

        { preview.alreadySent &&
          <div className="flex items-start space-x-2 text-sm text-gray-700 bg-yellow-100 border border-yellow-300 rounded p-3">
            <Icon icon={['fas', 'warning']} className="mt-0.5 text-warning" />
            <span>A review invitation has already been sent for this order.</span>
          </div>
        }

        <Input
          label="Subject"
          size="sm"
          value={subject}
          onChange={({ target: { value } }) => setSubject(value)}
        />

        <TextArea
          label="Message"
          size="sm"
          rows={14}
          className="text-sm"
          value={body}
          onChange={({ target: { value } }) => setBody(value)}
        />

        <div className="flex justify-between items-center">
          <Button variant="outline" state="secondary" onClick={() => modal.remove()}>
            Not now
          </Button>

          <Button disabled={sending || !subject.trim() || !body.trim()} onClick={onSend}>
            { sending ? 'Sending..' : 'Send invitation' }
          </Button>
        </div>
      </div>
    </Modal>
  )
})
